var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDropdownMenuIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 9,
    viewBox: "0 0 13 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.52802 8.43875C6.74995 8.43328 6.96207 8.34132 7.12332 8.18066L12.7262 2.51754C12.8972 2.34329 12.9956 2.10477 12.9999 1.85427C13.0041 1.60377 12.9138 1.36172 12.7488 1.18118C12.5838 1.00063 12.3576 0.896314 12.1197 0.891107C11.8818 0.8859 11.6516 0.980226 11.4796 1.1534L6.5 6.18973L1.52038 1.1534C1.34841 0.980225 1.11824 0.885899 0.880326 0.891106C0.642412 0.896313 0.416163 1.00063 0.251173 1.18118C0.0861813 1.36172 -0.00409165 1.60377 0.000141692 1.85427C0.00437503 2.10477 0.102767 2.34329 0.273753 2.51754L5.87669 8.18066C5.96343 8.26722 6.06574 8.33464 6.1776 8.37897C6.28945 8.42329 6.40859 8.44361 6.52802 8.43875Z",
    fill: "#0081DF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownMenuIcon);
export default __webpack_public_path__ + "static/media/dropdownMenuIcon.a8d6aa67666eee867e474ed73c76eed0.svg";
export { ForwardRef as ReactComponent };